import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "!ml-auto flex items-center" }

import { computed } from "vue";
import { Indexable } from "@types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPanel',
  props: [
    "src",
    "title",
    "subtitle",
    "href",
    "to",
    "color",
    "size",
    "border",
    "truncate",
    "reverse",
],
  setup(__props) {

const props = __props


const is = props.to ? "router-link" : props.href ? "a" : "div";

const colors: Indexable<string> = {
    black: "bg-black hover:bg-black/40",
    gray: "bg-neutral-900",
    transparent: "bg-transparent",
};

const borders: Indexable<string> = {
    black: "border-neutral-900",
    gray: "border-neutral-800",
    transparent: "border-transparent",
};

const sizes: Indexable<Indexable<string>> = {
    title: { xs: "text-xs", sm: "text-sm", md: "text-base" },
    subtitle: {
        xs: "text-[0.6rem]",
        sm: "text-xs",
        md: "text-sm",
    },
    img: {
        xs: "w-8 h-8",
        sm: "w-10 h-10",
        md: "w-12 h-12",
    },
};

const classes = computed(() => {
    const wrapper = [
        "flex items-center w-full rounded-xl p-2 space-x-3 transition duration-200 border",
        colors[props.color || "black"],
        props.border ? borders[props.color || "black"] : "border-transparent",
    ];
    const img = ["object-cover rounded-xl", sizes.img[props.size || "md"]];
    const title = [
        "font-semibold",
        sizes.title[props.size || "md"],
        props.truncate && "truncate",
        props.reverse && "order-last",
    ];
    const subtitle = [
        "text-neutral-400",
        props.truncate && "truncate",
        sizes.subtitle[props.size || "md"],
        props.reverse && "order-first",
    ];

    return { wrapper, img, title, subtitle };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(is)), {
    to: __props.to && __props.to,
    href: __props.href && __props.href,
    target: __props.href && '_blank',
    rel: __props.href && 'noopener noreferrer',
    class: _normalizeClass(_unref(classes).wrapper)
  }, {
    default: _withCtx(() => [
      (__props.src)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: _normalizeClass(_unref(classes).img),
            src: __props.src,
            alt: __props.title
          }, null, 10, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", {
          class: _normalizeClass(_unref(classes).title)
        }, _toDisplayString(__props.title), 3),
        (__props.subtitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_unref(classes).subtitle)
            }, _toDisplayString(__props.subtitle), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["to", "href", "target", "rel", "class"]))
}
}

})